import { useSelector } from 'react-redux'

import Warning from '@/components/util/feedback/Warning'
import { getEcomOrder } from '@/ducks/ecomOrderReducer'

import './ecom-order-dealer-instructions.scss'

const EcomOrderDealerInstructions = () => {
  const { dealer_instructions } = useSelector(getEcomOrder)

  if (!dealer_instructions?.trim()) return null

  return <Warning className="ecom-order-dealer-instructions">{dealer_instructions}</Warning>
}

export default EcomOrderDealerInstructions
